export default __webpack_public_path__ + "static/media/reglamento-de-directorio.cb59b1a4.pdf";